/* eslint-disable react/prop-types */
import { Box, Grid } from "@mui/material";
import DatepickerField from "components/DatepickerField";
import FormField from "components/FormField";
import SelectField from "components/SelectField";
import SwitchField from "components/SwitchField";

const provinceOptions = [
  { value: "Cần Thơ", label: "Cần Thơ" },
  { value: "Cần Thơ 2", label: "Cần Thơ 2" },
  { value: "Cần Thơ 3", label: "Cần Thơ 3" },
  { value: "Cần Thơ 4", label: "Cần Thơ 4" },
];
const districtOptions = [
  { value: "Cần Thơ 2", label: "Cần Thơ 2" },
  { value: "Cần Thơ 3", label: "Cần Thơ 3" },
  { value: "Cần Thơ 4", label: "Cần Thơ 4" },
];

export default function Fields({ formData }) {
  const { formField, values, errors, touched } = formData;
  const { taxCalculationPeriod, firstTime, supplementaryForThe, taxpayerName, taxId1, checkbox1 } =
    formField;
  return (
    <Box display="flex" flexDirection="column" gap={1}>
      <Grid spacing={3} container>
        <Grid item xs={4} style={{ paddingTop: 0 }}>
          <DatepickerField
            options={{
              dateFormat: "m-YY",
              plugins: [
                new monthSelectPlugin({
                  shorthand: true,
                  dateFormat: "m/Y",
                  theme: "light",
                }),
              ],
            }}
            name={taxCalculationPeriod.name}
            label={taxCalculationPeriod.label}
            error={errors.taxCalculationPeriod && touched.taxCalculationPeriod}
            success={
              values.taxCalculationPeriod?.toString().length > 0 && !errors.taxCalculationPeriod
            }
          />
        </Grid>
        <Grid item xs={4} style={{ paddingTop: 0 }}>
          <SwitchField name={firstTime.name} label={firstTime.label} value={values.firstTime} />
        </Grid>
        <Grid item xs={4} style={{ paddingTop: 0 }}>
          <FormField
            name={supplementaryForThe.name}
            label={supplementaryForThe.label}
            value={values.supplementaryForThe}
            error={errors.supplementaryForThe && touched.supplementaryForThe}
            success={
              values.supplementaryForThe?.toString().length > 0 && !errors.supplementaryForThe
            }
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={taxpayerName.name}
            label={taxpayerName.label}
            value={values.taxpayerName}
            error={errors.taxpayerName && touched.taxpayerName}
            success={values.taxpayerName?.toString().length > 0 && !errors.taxpayerName}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={taxId1.name}
            label={taxId1.label}
            value={values.taxId1}
            error={errors.taxId1 && touched.taxId1}
            success={values.taxId1?.toString().length > 0 && !errors.taxId1}
          />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <SwitchField name={checkbox1.name} label={checkbox1.label} value={values.checkbox1} />
        </Grid>
      </Grid>
    </Box>
  );
}
